module.exports = __webpack_public_path__ + "img/01焦点.38b760ed.png";